import { useRef, useEffect } from 'react';

// This hook returns the previous value that is different from the current one - NOTE: this is always different from current
export const usePreviousValue = <TValue>(value: TValue) => {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const previousRef = useRef<TValue>(undefined);
  const ref = useRef<TValue>(undefined);

  // Store current value in ref
  useEffect(() => {
    previousRef.current = ref.current;
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return previousRef.current;
};
